/*global
    jQuery
*/
(function ($) {
    var populateReviewWindow = function(e) {
        var $target = $(e.target),
            $wrapper = $target.parents('tr.pendingPet'),
            petId = $wrapper.find('input[name="petId"]').val();
        console.log('Review pet clicked for pet id ' + petId);
        $wrapper.parents('div.pending-review-dashboard').find('div.pet-review').load('/staff/pets/review-pet-panel/' + petId);
        $wrapper.parents('div.pending-review-dashboard').find('div.pet-review-modal').removeClass('closed');
    }

    var closeReviewWindow = function() {
       var $reviewWindow = $('div.pending-review-dashboard').find('div.pet-review');
       $reviewWindow.empty();
       $reviewWindow.parent('div.pet-review-modal').addClass('closed');
    }

    $('div.pet-review-modal').find('button.close').on('click', closeReviewWindow);

    var flagAll = function(e) {
        console.log('Clicked flag all!');
        var $target = $(e.target),
            $wrapper = $target.parents('div.grouped-pets');

        var ids = [];
        $wrapper.find('tr.pendingPet').each(function() {
            var $that = $(this);
            ids.push($that.find('input[name="petId"]').val());
        });

        var confirmation = confirm('Are you sure you want to delete pet IDs ' + ids.join(', ') + '?');
        if (confirmation == true) {
            $.get('/staff/pets/review-pending/flag-all', { 'ids': ids.join(',') }, function(response) {
                console.log(response);
                $wrapper.remove();
            });
            $target.blur();
            return false;
        } else {
            $target.blur();
            return false;
        }
    }
    var approveAll = function(e) {
        console.log('Clicked approve all!');
        var $target = $(e.target),
            $wrapper = $target.parents('div.grouped-pets');

        var ids = [];
        $wrapper.find('tr.pendingPet').each(function() {
            var $that = $(this);
            ids.push($that.find('input[name="petId"]').val());
        });

        var confirmation = confirm('Are you sure you want to approve pet IDs ' + ids.join(', ') + '?');
        if (confirmation == true) {
            $.get('/staff/pets/review-pending/approve-all', { 'ids': ids.join(',') }, function(response) {
                console.log(response);
                $wrapper.remove();
            });
            $target.blur();
        } else {
            $target.blur();
            return false;
        }
    }

    $('div.bulk-actions').find('input.flag-all').on('click', flagAll);
    $('div.bulk-actions').find('input.approve-all').on('click', approveAll);

    var approvePet = function(e) {
        var $target = $(e.target),
            $wrapper = $target.parents('tr.pendingPet'),
            petId = $wrapper.find('input[name="petId"]').val();
        console.log('Approve pet clicked for pet id ' + petId);
        $.get('/staff/pets/review-pending/approve/'+petId, function(response) {
            console.log(response);
            if (response.status == 'success') {
                $wrapper.remove();
                if (typeof response.pdpUrl !== 'undefined') {
                    window.open(response.pdpUrl, '_blank');
                }
                closeReviewWindow();
            }
        });
    }

    var flagPet = function(e) {
        var $target = $(e.target),
            $wrapper = $target.parent('div.pendingPet'),
            petId = $wrapper.find('input[name="petId"]').val();
        console.log('Flag pet clicked for pet id ' + petId);
        $.get('/staff/pets/review-pending/flag/'+petId, function(response) {
            console.log(response);
            if (response.status == 'success') {
                $wrapper.remove();
                closeReviewWindow();
            }
        });
    }

    $(document).find('input.flag-pet').on('click', flagPet);
    $('input.approve-pet').on('click', approvePet);
    $('input.review-pet').on('click', populateReviewWindow);
}(jQuery));
